<template>
  <div class="menu-wrapper">
    <template v-for="(item,index) in menuData">
      <!--只有一级菜单 -->
      <el-menu-item v-if="onlyOne(item)" :index="filterPath(item)" class="first-level-menu-item" @click="openPage(item)" :key="item.label">
        <div class="menu-item-box flex acenter" :style="getMenuItemBoxPL(item)">
          <img v-if="item.img" :src="require(`@/assets/img/v2/menu/${item.img === true ? item.label : item.img}.png`)" class="mr5 size16"/>
          <span slot="title" class="menu-item-title" :class="{'el-menu--display':isCollapse}">{{ $t(`menu.${item.label}`) }}</span>
        </div>
      </el-menu-item>
      <!--多级菜单-->
      <el-submenu v-if="item.children && item.children.length > 0" :index="filterPath(item)" :key="item.label">
        <!--父级菜单-->
        <template slot="title">
          <div class="submenu-box flex acenter">
            <img v-if="item.img" :src="require(`@/assets/img/v2/menu/${item.img === true ? item.label : item.img}.png`)" class="mr5 size16"/>
            <span slot="title" :class="{'el-menu--display':isCollapse}">{{ $t(`menu.${item.label}`) }}</span>
            <img v-if="!isCollapse && item.paid" src="@/assets/img/v2/menu/paid.png" class="mr5 wpx40 hpx15 ml8"/>
          </div>
        </template>
        <!--子级菜单-->
        <template v-for="(child,cindex) in item.children">
          <sidebar-item v-if="child.children && child.children.length > 0" :menuData="[child]" :key="cindex"
                        :isCollapse="isCollapse"></sidebar-item>
          <el-menu-item v-else :index="filterPath(child)" @click="openPage(child)" :key="cindex">
            <div class="menu-item-box flex acenter" :style="getMenuItemBoxPL(child)">
              <span slot="title">{{ $t(`menu.${child.label}`) }}</span>
            </div>
          </el-menu-item>
        </template>
      </el-submenu>
    </template>
  </div>
</template>
<script>
import {ygjMenuParamTo} from "@/api/user/login";
import {aveLog} from "@/api/user/user";
import {mapGetters, mapMutations} from "vuex";

export default {
  name: 'SidebarItem',
  data() {
    return {
      menus: null
    };
  },
  inject: ['reload'],
  props: {
    menuData: {
      type: Array,
    },
    isCollapse: {
      type: Boolean,
    },
    showIcon: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  created() {
    this.setmenus(this.menuData);
  },
  mounted() {
  },
  computed: {
    ...mapGetters(['isCollapse', 'ygj', 'userInfo']),
    onlyOne() {
      const that = this;
      return function (item) {
        if (!item.children || item.children.length === 0) {
          return true;
        }
      };
    },
  },
  methods: {
    ...mapMutations({
      SET_YGJ: 'SET_YGJ',
      SET_MENU_LOADING: 'SET_MENU_LOADING'
    }),
    setmenus(menus1) {
      for (let i = 0; i < menus1.length; i++) {
        if (null != menus1[i].children) {
          let children = menus1[i].children
          for (let j = 0; j < children.length; j++) {
            //判断入职管理
            if (children[j].permission == "hr_set_entry") {
              sessionStorage.setItem("ruZhi", JSON.stringify("入职管理"))
            }
            //判断员工管理/生日提醒
            if (children[j].permission == "hr_emp_manage") {
              sessionStorage.setItem("yuanGong", JSON.stringify("员工管理"))
            }
            //判断合同管理
            if (children[j].permission == "hr_contract_manage") {
              sessionStorage.setItem("heTong", JSON.stringify("合同管理"))
            }
            //判断数据准备/薪资待完成批次
            if (children[j].permission == "hr_wage__new_data_ready") {
              sessionStorage.setItem("xinZi", JSON.stringify("薪资待完成"))
            }
          }
        }
      }
    },
    filterPath(menu) {
      return menu.path == null ? menu.id : menu.path;
    },
    //判断两个对象值相不相等
    isEqual(a, b) {
      const classNameA = toString.call(a)
      const classNameB = toString.call(b)
      // 如果数据类型不相等，则返回false
      if (classNameA !== classNameB) {
        return false
      } else {
        // 如果数据类型相等，再根据不同数据类型分别判断
        if (classNameA === '[object Object]') {
          for (let key in a) {
            if (!this.isEqual(a[key], b[key])) return false
          }
          for (let key in b) {
            if (!this.isEqual(a[key], b[key])) return false
          }
          return true
        } else if (classNameA === '[object Array]') {
          if (a.length !== b.length) {
            return false
          } else {
            for (let i = 0, len = a.length; i < len; i++) {
              if (!this.isEqual(a[i], b[i])) return false
            }
            return true
          }
        } else if (classNameA === '[object Function]') {
          return a.toString() === b.toString()
        } else {
          return Object.is(a, b)
        }
      }
    },
    openPage(item) {
      if (!item.url) {
        let path = item.path;
        let params = "";
        // 处理路由URL带参数的菜单
        if (typeof item.params === 'function') {
          params = item.params(this.$store);
          if (item.path && item.path.indexOf('/:') !== -1) {
            const pathItemArr = item.path.split('/');
            pathItemArr.forEach((pathItem) => {
              if (pathItem.indexOf(':') === 0) {
                const paramName = pathItem.substring(1);
                path = path.replace(pathItem, params[paramName])
              }
            })
          }
        }
        if (item.path === this.$route.path) {
          this.reload();
          if (item.query != undefined) {
            this.$router.push({
              path: path,
              query: item.query,
            });
          }
        } else {
          this.$router.push({
            path: path,
            query: item.query,
          });
        }
      } else {
        const id = item.id;
        const url = item.url;
        const path = item.path;
        const fullPath = item.fullPath;
        if (fullPath) {
          this.$router.push({
            path: item.path
          });
        } else {
          this.loadingUrl(true)
          let params = {
            targetUrl: url,
            ygjCusId: this.userInfo.ygjCusId,
            ygjUserId: this.userInfo.ygjUserId
          }
          ygjMenuParamTo(params)
            .then(response => {
              this.loadingUrl(false);
              const fullPathRes = response.data.data;
              this.setFullPath(url, path, fullPathRes);
            })
            .catch(error => {
              this.loadingUrl(false);
            })
        }
      }
      const menuName = this.$t(`menu.${item.label}`);
      aveLog({ operFunname: menuName })
        .then(res => {})
    },
    loadingUrl(isLoading) {
      this.SET_MENU_LOADING(isLoading);
    },
    setFullPath(targetUrl, path, fullPath) {
      const ygj = this.ygj;
      for (let i = 0; i < ygj.length; i++) {
        if (ygj[i].url == targetUrl) {
          ygj[i].fullPath = fullPath;
          break;
        }
      }
      this.SET_YGJ(ygj);
      this.$router.push({
        path: path
      });
    },
    getMenuItemBoxPL(val){
      let level = val.level || 1;
      return {
        'padding-left': level * 21 + 'px'
      }
    }
  }
};
</script>
<style lang="scss" scoped>
  .el-menu-item {
    background: #FFFFFF !important;
    padding: 0 20px !important;
    
    .menu-item-box {
      padding-left: 20px;
      
      span {
        color: #666666 !important;
      }
      &:hover {
        background: rgba(255,150,1,0.06) !important;
      }
    }
    
    &.is-active {
      .menu-item-box {
        background: rgba(255,150,1,0.06) !important;
        
        span {
          color: #FF9601 !important;
        }
      }
    }
  }
  
  .el-submenu {
    background-color: #FFFFFF !important;
    
    .submenu-box {
      height: 56px;
    }
    ::v-deep .el-submenu__title {
      span {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #1C1C1C;
        line-height: 22px;
      }
      &:hover {
        background: rgba(255,150,1,0.06) !important;
      }
    }
    ::v-deep .el-submenu__icon-arrow {
      font-size: 14px !important;
      
      &:before {
        content: '\E790' !important;
      }
    }
    &.is-opened ::v-deep .el-submenu__title .el-submenu__icon-arrow {
      color: #FF9601 !important;
    }
  }
  
  .first-level-menu-item {
    padding: 0 !important;
    
    .menu-item-box {
      height: 56px;
      padding-left: 20px !important;
      
      .menu-item-title {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 22px;
      }
    }
  }
</style>
